import React from "react";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { Link, useLocation } from "react-router-dom";
import styles from "./breadcrumbs.module.css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

function Breadcrumbs({ color }) {
  const location = useLocation();

  // Define custom routes with their display names
  const routes = [
    { path: "/", breadcrumb: "Home" },
    { path: "/fixed-deposit-rates", breadcrumb: "Fixed Deposit" },
    { path: "/savings-account-interest-rates", breadcrumb: "Savings Deposit" },
    { path: "/fcnr-deposit-rates", breadcrumb: "FCNR Deposit Rates" },
    { path: "/content", breadcrumb: "Learning Centre" },
    { path: "/feedback", breadcrumb: "Feedback" },
    { path: "/privacy", breadcrumb: "Privacy Policy" },
    { path: "/terms-and-condition", breadcrumb: "Terms & Conditions" },
    { path: "/blog", breadcrumb: "Blog" },
    { path: "/credit-cards", breadcrumb: "Credit Cards" },
    { path: "/fuel-credit-cards", breadcrumb: "Fuel Credit Cards" },
    { path: "/fuel-credit-cards/:ccid", breadcrumb: "Card Details" },
    { path: "/blog/:id", breadcrumb: "Blog details" },
    { path: "/verify-email/:token", breadcrumb: null },
    { path: "/forgot-password/:uid/:token", breadcrumb: "Forget password" },
  ];

  // Custom function to get redirect path logic
  const getRedirectPath = (pathname) => {
    switch (pathname) {
      case "/fixed-deposit-rates":
        return "/fixed-deposit-rates";
      case "/savings-account-interest-rates":
        return "/savings-account-interest-rates";
      default:
        return pathname;
    }
  };

  const breadcrumbs = useBreadcrumbs(routes);

  // Filter out null breadcrumbs (like tokens)
  const filteredBreadcrumbs = breadcrumbs.filter(
    ({ breadcrumb }) => breadcrumb !== null,
  );

  return (
    <div
      className={styles.breadcrumbsContainer}
      style={{ backgroundColor: color }}
    >
      <div className={styles.breadcrumbSubCont}>
        <div className={styles.breadcrumbSubDiv}>
          {filteredBreadcrumbs.map(({ breadcrumb, match }, index) => {
            // Security check for token paths
            if (match.pathname.includes("token")) return null;

            const redirectPath = getRedirectPath(match.pathname);

            // SEO Improvement: Check if this is the current page
            const isActive = match.pathname === location.pathname;

            return (
              <React.Fragment key={match.pathname}>
                {/* Visual Separator: Render icon for all items except the first (Home) */}
                {index > 0 && (
                  <NavigateNextIcon
                    sx={{
                      color: "#5f6368",
                      marginRight: "5px",
                      marginLeft: "5px",
                      fontSize: 17,
                      verticalAlign: "middle",
                    }}
                  />
                )}

                {isActive ? (
                  // CURRENT PAGE: Render as text (span), not a link
                  <span className={styles.breadcrumbActive}>
                    {breadcrumb.props.children.replaceAll("%20", " ")}
                  </span>
                ) : (
                  // PREVIOUS PAGES: Render as clickable links
                  <Link to={redirectPath} className={styles.breadcrumb}>
                    {breadcrumb.props.children.replaceAll("%20", " ")}
                  </Link>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Breadcrumbs;
